import {Component, OnInit} from 'angular2/core';
import {CampaignService} from "../../campaigns/campaign.service";
import {RouteParams, Router} from "angular2/router";
import {AlertService} from "../../common/alerts/alert.service";
import {TranslateService, TranslatePipe} from "ng2-translate";
import {Campaign} from "../../../models/campaign.model";
import {DatePipe} from "angular2/common";
import {VoucherService} from "../voucher.service";
import {Voucher} from "../../../models/voucher.model";
import {ProductService} from "../../products/product.service";

@Component({
    templateUrl: './app/components/vouchers/show/show.html',
    providers: [CampaignService, VoucherService, ProductService],
    pipes: [TranslatePipe, DatePipe]
})

export class ShowVoucherComponent implements OnInit {
    campaign:Campaign;
    products:string[];
    voucher:Voucher;

    constructor(private _alert_service:AlertService, private _router:Router, private _voucherService:VoucherService,
                private _translateService:TranslateService, private _params:RouteParams, private _campaignService:CampaignService,
                private _productService:ProductService) {
        this.campaign = new Campaign({});
        this.voucher = new Voucher({});
    }

    ngOnInit() {
        this._campaignService.getCampaign(this._params.get("campaignId")).subscribe(campaign => {
            this.campaign = campaign;
            this._productService.getProductsByIds(this.campaign.country, this.campaign.products)
                .subscribe(products => this.products = products);
        });
        this._voucherService.getVoucher(this._params.get("voucherCode")).subscribe(voucher => this.voucher = voucher);
    }


    destroyVoucher() {
        let result = confirm(this._translateService.instant('vouchers.delete.confirm'));
        if (result) {
            this._voucherService.destroyVoucher(this.voucher.code).subscribe(a => {
                    this._router.navigate(['Vouchers', {"campaignId": this.campaign.id}]);
                    this._alert_service.pushAlert({
                        type: "success",
                        msg: this._translateService.instant("vouchers.delete.success"),
                        closeable: true
                    });
                },
                error => this._alert_service.pushAlert({
                    type: "danger",
                    msg: this._translateService.instant(error),
                    closeable: true
                })
            );
        }
    }
}